export default __webpack_public_path__ + "media/Fisheye_right.3656a3884207773006205e710d28b099.svg";